var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66656 6.66634L1.66656 7.08301C1.66656 7.77336 2.22621 8.33301 2.91656 8.33301L7.08323 8.33301C7.77359 8.33301 8.33323 7.77336 8.33323 7.08301L8.33323 6.66634M6.66656 4.99967L4.9999 6.66634M4.9999 6.66634L3.33323 4.99967M4.9999 6.66634L4.9999 1.66634",
    stroke: "#545F71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGrey);
export default __webpack_public_path__ + "static/media/download-grey.edd4cc1df1ed984026c8500721759cf0.svg";
export { ForwardRef as ReactComponent };